/**
 * ReponsavelAssociado
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ReponsavelAssociadoCollection} from '@/model/collection/ReponsavelAssociadoCollection'

/* TODO: review generated class */
export class ReponsavelAssociado extends Resource {
  idAssociadoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  razaoSocial: string | null = null
  nomeFantasia: string | null = null
  cnpj: string | null = null
  ativo: boolean | null = null

  @ResponseExclude()
  senha: string | null = null

  get $id() {
    return this.idAssociadoPk
  }
  set $id(val) {
    this.idAssociadoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ReponsavelAssociado
   */
  async getReponsavelAssociado(id: number) {
    return await Request.get(`/admin/reponsavel-associado/${id}`)
      .name('getReponsavelAssociado')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ReponsavelAssociado
   */
  async removeReponsavelAssociado() {
    return await Request.delete(`/admin/reponsavel-associado/${this.$id}`)
      .name('removeReponsavelAssociado')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ReponsavelAssociado
   */
  static async listReponsavelAssociado(params: any) {
    return await Request.get(`/admin/reponsavel-associado`, {params})
      .name('listReponsavelAssociado')
      .as(ReponsavelAssociadoCollection)
      .getData()
  }

  /**
   * Persists a new instance of ReponsavelAssociado. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistReponsavelAssociado() {
    return await Request.post(`/admin/reponsavel-associado`, this)
      .name('persistReponsavelAssociado')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ReponsavelAssociado to use it in a CSV file
   */
  static async listCsvReponsavelAssociado(params: any) {
    return await Request.get(`/admin/reponsavel-associado/csv`, {params})
      .name('listCsvReponsavelAssociado')
      .as(ReponsavelAssociadoCollection)
      .getData()
  }
}
